import React, { useEffect, useState } from "react";
import Radio from "../../components/radio/Radio";
import { Link } from "react-router-dom";
import Moment from "react-moment";
import moment from "moment";
import Cookies from "universal-cookie";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { postLeaveApplicationForm } from "../../api/leaveApplicationForm";
import { useNavigate } from "react-router-dom";
import { subDays, addDays } from "date-fns";
import {
  DISCRETIONAL_LEAVE_YEAR_IGNORE,
  MIN_LEAVE_DATE_FOR_CL,
  MIN_LEAVE_DATE_FOR_PL,
  ROLE,
} from "../../config";
import toast from "react-hot-toast";
import useEmployeeLeaveStructure from "../../hooks/leaveApplication/useEmployeeLeaveStructure";
import InlineLoader from "../../components/loader/InlineLoader";
import { Button } from "../../components/ui";
import { ClockIcon } from "@heroicons/react/solid";
import UtilizedLeavesModal from "../../components/modals/UtilizedLeavesModal";

const cookies = new Cookies();

const IS_REQUIRED = true;
function LeaveApplicationForm() {
  let initialState = {
    type_of_leave: "",
    leave_head_id: "",
    leave_head_name: "",
    leave_date_from: "",
    leave_date_fromForm: "",
    leave_date_to: "",
    leave_date_toForm: "",
    leave_date_to_min_date: "",
    total_leave: 0,
    reason: "",
    is_half_day: false,
    half_day_type: "FIRST_HALF", // Default to FIRST_HALF
  };
  const date = new Date();
  const [role, setRole] = useState("");
  useEffect(() => {
    setRole(cookies.get(ROLE));
  }, []);
  const navigate = useNavigate();
  const [leaveApplicationData, setLeaveApplicationData] =
    useState(initialState);
  const [minDate, setminDate] = useState(
    new Date(moment().add(MIN_LEAVE_DATE_FOR_PL, "days").calendar())
  );
  const [medicalCertificate, setMedicalCertificate] = useState();
  const [dateError, setDateError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const { leaveStructureList, isLoading: isLeaveStructureLoading } =
    useEmployeeLeaveStructure();
  const [isDocumentRequired, setIsDocumentRequired] = useState(false);
  const [isUtilizedModalOpen, setIsUtilizedModalOpen] = useState(false);

  useEffect(() => {
    if (
      leaveApplicationData.total_leave > 1 &&
      leaveApplicationData.is_half_day
    ) {
      setLeaveApplicationData({
        ...leaveApplicationData,
        is_half_day: false,
        half_day_type: "FIRST_HALF",
      });
    }
  }, [leaveApplicationData.total_leave]);

  const handleLeaveForm = (e) => {
    let value = e.target.value;
    let data = {
      ...leaveApplicationData,
      [e.target.name]: value,
    };
    setLeaveApplicationData(data);
  };

  const handleCheckboxChange = (e) => {
    const { name, checked } = e.target;
    setLeaveApplicationData({
      ...leaveApplicationData,
      [name]: checked,
    });
  };

  const handleHalfDayTypeChange = (e) => {
    const { value } = e.target;
    setLeaveApplicationData({
      ...leaveApplicationData,
      half_day_type: value,
    });
  };

  const handleLeaves = (e) => {
    let data;
    let value = e.target.value;
    const selectedLeave = leaveStructureList?.data?.data.find(
      (leave) => leave.leave_head_id === value
    );

    data = {
      ...leaveApplicationData,
      type_of_leave: value,
      leave_head_id: selectedLeave?.leave_head_id,
      leave_head_name: selectedLeave?.leave_head_name,
      leave_date_from: "",
      leave_date_fromForm: "",
      leave_date_to: "",
      leave_date_toForm: "",
      total_leave: 0,
      reason: "",
      is_half_day: false,
      half_day_type: "FIRST_HALF",
    };

    setminDate(subDays(new Date(), 0));
    setIsDocumentRequired(selectedLeave?.is_document_required || false);
    setLeaveApplicationData(data);
  };

  const handleDate = (value, name) => {
    setDateError(false);
    let data;
    data = {
      ...leaveApplicationData,
      [name]: moment(new Date(value)).format(),
      [`${name}Form`]: value,
    };

    switch (name) {
      case "leave_date_from":
        data = {
          ...leaveApplicationData,
          ...data,
          leave_date_to_min_date: addDays(new Date(value), 0),
          leave_date_toForm: "",
          leave_date_to: "",
          total_leave: 0,
        };
        break;
      case "leave_date_to":
        data = {
          ...leaveApplicationData,
          ...data,
          total_leave: handleTotalLeaveCalculation(value),
        };
        break;
      default:
        break;
    }
    setLeaveApplicationData(data);
  };

  const handleMedicalCerificated = (e) => {
    setMedicalCertificate(e.target.files);
  };

  const handleTotalLeaveCalculation = (value) => {
    let totalLeave = 0;
    totalLeave = leaveApplicationData.leave_date_from
      ? moment(value).diff(leaveApplicationData.leave_date_from, "days") + 1
      : 0;
    return totalLeave;
  };

  const handleSubmitLeaveForm = (e) => {
    e.preventDefault();

    // Validate required date fields
    if (!leaveApplicationData.leave_date_from) {
      toast.error("From Date is required");
      return;
    }

    if (!leaveApplicationData.leave_date_to) {
      toast.error("To Date is required");
      return;
    }

    setIsLoading(true);

    //  Set half_day_type to empty string if is_half_day is false
    const finalPayload = {
      ...leaveApplicationData,
      half_day_type: leaveApplicationData.is_half_day
        ? leaveApplicationData.half_day_type
        : "",
    };

    // Console log the payload before submission
    console.log("Leave Application Payload:", finalPayload);

    postLeaveApplicationForm(
      finalPayload,
      isDocumentRequired ? medicalCertificate : null
    )
      .then((res) => {
        toast.success("Leaves Applied Successfully");
        setIsLoading(false);
        setTimeout(() => {
          navigate("/");
        }, 2000);
      })
      .catch((err) => {
        setIsLoading(false);
        const { status, data } = err.response;
        if (status >= 400 || status <= 499) {
          toast.error(data.message);
        } else {
          toast.error("Internal server error");
        }
      });
  };
  // const handleLeaves = (e) => {
  //     let data;
  //     let value = e.target.value
  //     data = {
  //         ...leaveApplicationData,
  //         [e.target.name]: value,
  //         leave_date_from: '',
  //         leave_date_fromForm: '',
  //         leave_date_to: '',
  //         leave_date_toForm: '',
  //         total_leave: 0,
  //         reason: ''
  //     }
  //     switch (value) {
  //         case 'CL':
  //             setminDate(subDays(new Date(), 0))
  //             setNote('Note: Maximum 3 days of leave')
  //             break;
  //         case 'PL':
  //             setminDate(subDays(new Date(), 0))
  //             break;
  //         case 'OL':
  //             setminDate(new Date(moment().add(MIN_LEAVE_DATE_FOR_PL, 'days').calendar()))
  //             setNote('')
  //             break;
  //         case 'DL':
  //             setminDate(subDays(new Date().getFullYear() === DISCRETIONAL_LEAVE_YEAR_IGNORE ? new Date('2023/01/01') : new Date(), 0))
  //             setNote('')
  //             break;
  //         case 'SL':
  //             setminDate(null)
  //             setNote('Note: Minimum 4 days of leave to be selected')
  //             data = {
  //                 ...leaveApplicationData,
  //                 ...data,
  //                 reason: 'Sick'
  //             }
  //             break;
  //         default:
  //             break;
  //     }
  //     setLeaveApplicationData(data)
  // }
  // const handleDate = (value, name) => {
  //     setDateError(false)
  //     let data;
  //     data = {
  //         ...leaveApplicationData,
  //         [name]: moment(new Date(value)).format(),
  //         [`${name}Form`]: value,
  //     }
  //     if (leaveApplicationData.type_of_leave === 'DL') {
  //         data = {
  //             ...leaveApplicationData,
  //             ...data,
  //             total_leave: 1,
  //         }
  //         setLeaveApplicationData(data)
  //         return
  //     }
  //     switch (name) {
  //         case 'leave_date_from':
  //             data = {
  //                 ...leaveApplicationData,
  //                 ...data,
  //                 leave_date_to_min_date: addDays(new Date(value), 0),
  //                 leave_date_toForm: '',
  //                 leave_date_to: '',
  //                 total_leave: 0
  //             }
  //             break;
  //         case 'leave_date_to':
  //             data = {
  //                 ...leaveApplicationData,
  //                 ...data,
  //                 total_leave: handleTotalLeaveCalculation(value)
  //             }
  //             break;
  //         default:
  //             break;
  //     }
  //     setLeaveApplicationData(data)
  // }
  // const handleMedicalCerificated = (e) => {
  //     setMedicalCertificate(e.target.files)
  // }
  // const handleTotalLeaveCalculation = (value) => {
  //     let totalLeave = 0
  //     totalLeave = leaveApplicationData.leave_date_from ? moment(value).diff(leaveApplicationData.leave_date_from, 'days') + 1 : 0
  //     return totalLeave
  // }
  // const handleSubmitLeaveForm = (e) => {
  //     setIsLoading(true)
  //     e.preventDefault()
  //     if (validateNumberOfLeaves()) {
  //         postLeaveApplicationForm(leaveApplicationData, medicalCertificate)
  //             .then((res) => {
  //                 toast.success("Leaves Applied Successfully")
  //                 setIsLoading(false)
  //                 setTimeout(() => {
  //                     navigate('/')
  //                 }, 2000)
  //             })
  //             .catch((err) => {
  //                 setIsLoading(false)
  //                 const { status, data } = err.response
  //                 if (status >= 400 || status <= 499) {
  //                     toast.error(data.message)
  //                 } else {
  //                     toast.error("Internal server error")
  //                 }
  //             })
  //     } else {
  //         setIsLoading(false)
  //     }
  // }

  // const validateNumberOfLeaves = () => {
  //     let isSafe = false
  //     const { type_of_leave, total_leave } = leaveApplicationData
  //     if (type_of_leave === 'SL') return true
  //     if (type_of_leave === 'DL') return true
  //     if (type_of_leave === 'OL') return true
  //     if (type_of_leave === 'CL' && total_leave <= 3) {
  //         return isSafe = true
  //     }
  //     if (type_of_leave === 'PL' && total_leave >= MIN_LEAVE_DATE_FOR_PL) {
  //         return isSafe = true
  //     }
  //     setDateError(true)
  //     return isSafe
  // }
  return (
    <>
      <div className="bg-[color:var(--color3)] min-h-screen py-6">
        <div className="container mx-auto max-w-5xl bg-white rounded-lg shadow-md">
          <form onSubmit={handleSubmitLeaveForm}>
            <div className="p-6">
              <div className="flex flex-col sm:flex-row sm:items-center justify-between mb-6 border-b pb-3 gap-3">
                <h2 className="text-2xl font-bold text-gray-800">
                  Leave Application Form
                </h2>
                <Button
                  type="button"
                  variant="outline"
                  onClick={() => setIsUtilizedModalOpen(true)}
                  className="flex items-center gap-2 self-start sm:self-auto border-gray-300 hover:bg-gray-50 text-gray-700"
                >
                  <ClockIcon className="w-4 h-4 text-primary" />
                  <span>View Utilized Leaves</span>
                </Button>
              </div>

              <div className="mb-6 flex items-center">
                <label
                  htmlFor="date"
                  className="text-xl font-semibold text-gray-700 inline-block"
                >
                  Current Date:
                </label>
                <span className="text-xl font-medium text-gray-700 inline-block ml-3 bg-gray-100 px-3 py-1 rounded">
                  <Moment format="D MMM YYYY">{date}</Moment>
                </span>
              </div>

              <div className="space-y-6">
                <div className="bg-gray-50 p-4 rounded-lg">
                  <p>
                    <label
                      htmlFor="reason"
                      className="label text-lg font-medium"
                    >
                      Type of leave: <span className="text-red-500">*</span>
                    </label>
                  </p>
                  <div className="flex flex-wrap mt-3 gap-4">
                    {isLeaveStructureLoading ? (
                      <div className="flex items-center space-x-2 p-2 border rounded bg-white">
                        <InlineLoader className="text-blue-600" />
                        <span className="text-gray-600">
                          Loading leave types...
                        </span>
                      </div>
                    ) : (
                      leaveStructureList?.data?.data.map((leave) => (
                        <Radio
                          key={leave.leave_head_id}
                          label={leave.leave_head_name}
                          name="type_of_leave"
                          value={leave.leave_head_id}
                          onChange={handleLeaves}
                        />
                      ))
                    )}
                  </div>
                </div>

                {leaveApplicationData?.type_of_leave && (
                  <div className="bg-white border rounded-lg p-5">
                    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                      <div className="bg-gray-50 rounded-lg p-4">
                        <label
                          htmlFor="leave_date"
                          className="label font-medium mb-2 block"
                        >
                          Date Range: <span className="text-red-500">*</span>
                        </label>
                        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
                          <div className="flex flex-col">
                            <label className="text-sm text-gray-600 mb-1">
                              From Date:
                            </label>
                            <DatePicker
                              name="leave_date_from"
                              autoComplete="false"
                              className="input w-full border-2 border-gray-300 focus:border-blue-500 focus:ring focus:ring-blue-200 transition-all"
                              dateFormat="dd/MM/yyyy"
                              minDate={minDate}
                              selected={
                                leaveApplicationData?.leave_date_fromForm
                              }
                              onChange={(value) =>
                                handleDate(value, "leave_date_from")
                              }
                              placeholderText="Select start date"
                            />
                          </div>

                          <div className="flex flex-col">
                            <label className="text-sm text-gray-600 mb-1">
                              To Date:
                            </label>
                            <DatePicker
                              className="input w-full border-2 border-gray-300 focus:border-blue-500 focus:ring focus:ring-blue-200 transition-all"
                              autoComplete="false"
                              dateFormat="dd/MM/yyyy"
                              minDate={
                                leaveApplicationData?.leave_date_to_min_date
                              }
                              selected={leaveApplicationData?.leave_date_toForm}
                              onChange={(value) =>
                                handleDate(value, "leave_date_to")
                              }
                              disabled={!leaveApplicationData?.leave_date_from}
                              placeholderText={
                                leaveApplicationData?.leave_date_from
                                  ? "Select end date"
                                  : "First select start date"
                              }
                            />
                          </div>
                        </div>
                      </div>

                      <div className="bg-gray-50 rounded-lg p-4">
                        <label
                          htmlFor="total_leave"
                          className={`label font-medium mb-2 block ${
                            dateError ? "text-red-700" : ""
                          }`}
                        >
                          Total Leave Days
                        </label>
                        <div className="flex items-center">
                          <input
                            type="number"
                            name="total_leave"
                            readOnly
                            disabled
                            className={`input w-full text-lg font-medium disabled:bg-gray-100 disabled:cursor-not-allowed ${
                              dateError ? "border-red-700" : ""
                            }`}
                            placeholder="Total leave days will appear here"
                            value={leaveApplicationData.total_leave}
                          />
                        </div>
                      </div>

                      {/* Half-day leave options */}
                      <div className="col-span-1 lg:col-span-2 bg-gray-50 rounded-lg p-4">
                        <div className="flex items-center">
                          <input
                            type="checkbox"
                            id="half_day"
                            name="is_half_day"
                            checked={leaveApplicationData.is_half_day}
                            onChange={handleCheckboxChange}
                            disabled={leaveApplicationData.total_leave > 1}
                            className={`mr-2 h-5 w-5 text-blue-600 border-gray-300 rounded focus:ring-blue-500 ${
                              leaveApplicationData.total_leave > 1
                                ? "opacity-50 cursor-not-allowed"
                                : ""
                            }`}
                          />
                          <label
                            htmlFor="half_day"
                            className="text-gray-800 font-medium"
                          >
                            Half Day Leave
                          </label>
                        </div>

                        <div className="mt-1 text-sm text-gray-500">
                          {leaveApplicationData.total_leave > 1 ? (
                            <span className="text-amber-600">
                              Note: Half day option is only available for single
                              day leave requests.
                            </span>
                          ) : (
                            <span>
                              Select this option if you want to take a half day
                              leave.
                            </span>
                          )}
                        </div>

                        {/* Show half-day options only when half-day is checked */}
                        {leaveApplicationData.is_half_day && (
                          <div className="mt-3 pl-6 bg-white p-3 border border-gray-200 rounded">
                            <p className="text-sm text-gray-600 mb-2">
                              Select which half of the day:
                            </p>
                            <div className="flex items-center space-x-6">
                              <div className="flex items-center">
                                <input
                                  type="radio"
                                  id="first_half"
                                  name="half_day_type"
                                  value="FIRST_HALF"
                                  checked={
                                    leaveApplicationData.half_day_type ===
                                    "FIRST_HALF"
                                  }
                                  onChange={handleHalfDayTypeChange}
                                  className="mr-2 h-4 w-4 text-blue-600 border-gray-300"
                                />
                                <label
                                  htmlFor="first_half"
                                  className="text-gray-700"
                                >
                                  First Half (Morning)
                                </label>
                              </div>
                              <div className="flex items-center">
                                <input
                                  type="radio"
                                  id="second_half"
                                  name="half_day_type"
                                  value="SECOND_HALF"
                                  checked={
                                    leaveApplicationData.half_day_type ===
                                    "SECOND_HALF"
                                  }
                                  onChange={handleHalfDayTypeChange}
                                  className="mr-2 h-4 w-4 text-blue-600 border-gray-300"
                                />
                                <label
                                  htmlFor="second_half"
                                  className="text-gray-700"
                                >
                                  Second Half (Afternoon)
                                </label>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>

                      {isDocumentRequired && (
                        <div className="col-span-1 lg:col-span-2 bg-gray-50 rounded-lg p-4">
                          <label
                            htmlFor="medical_certificates"
                            className="label font-medium mb-2 block"
                          >
                            Upload Medical Documents:{" "}
                            <span className="text-red-500">*</span>
                          </label>
                          <div className="bg-white border-2 border-dashed border-gray-300 rounded-lg p-4 text-center">
                            <small className="inline-block mb-2 text-red-600 font-medium">
                              Note: Medical Document is required
                            </small>
                            <input
                              type="file"
                              multiple
                              required={isDocumentRequired}
                              name="medical_certificates"
                              className="w-full text-gray-700 p-2"
                              onChange={handleMedicalCerificated}
                            />
                          </div>
                        </div>
                      )}
                    </div>

                    <div className="mt-6 bg-gray-50 rounded-lg p-4">
                      <p>
                        <label htmlFor="reason" className="label font-medium">
                          Reason: <span className="text-red-500">*</span>
                        </label>
                      </p>
                      <textarea
                        id="reason"
                        required={IS_REQUIRED}
                        name="reason"
                        placeholder="Please explain your reason for taking leave..."
                        rows="4"
                        cols="50"
                        className="text_area w-full mt-2 border-2 border-gray-300 focus:border-blue-500 focus:ring focus:ring-blue-200 transition-all rounded-lg"
                        value={leaveApplicationData.reason}
                        onChange={handleLeaveForm}
                      />
                    </div>

                    <div className="mt-8">
                      <div className="flex justify-center">
                        <Button
                          type="submit"
                          disabled={isLoading}
                          className="transition-all duration-300 disabled:opacity-70 disabled:cursor-not-allowed shadow-md hover:shadow-lg"
                        >
                          {isLoading && <InlineLoader className="mr-2" />}
                          {isLoading ? "Submitting..." : "Submit Application"}
                        </Button>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </form>
        </div>
      </div>
      <UtilizedLeavesModal
        isOpen={isUtilizedModalOpen}
        onClose={() => setIsUtilizedModalOpen(false)}
      />
    </>
  );
}

export default LeaveApplicationForm;
